import { Typography } from 'antd'
import { CIMSTabs } from 'components/CIMSTabs'
import ReportFilenames from './components/ReportFilenames'
import ReportFilenamesProvider from './components/ReportFilenames/ReportFilenamesContext'
import Warnings from './components/Warnings'
import ReportRecordSelectProvider from 'components/CIMSSelect/common/ReportRecordSelect/ReportRecordSelectContext'
import PhotoFilenames from './components/PhotoFilenames'
import PhotoFilenamesProvider from './components/PhotoFilenames/PhotoFilenameContext'
import PhotoExportRecordSelectProvider from 'components/CIMSSelect/common/PhotoExportRecordSelect/PhotoExportRecordSelectContext'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import { CustomFieldClassType } from 'shared'

const Filenames: React.FC = () => {
  return (
    /**
     * i know this isn't very "forward" thinking, but the work to make it dynamic with
     * everything that depends on it is more work than is worth right now
     */
    <ProjectCustomFieldsProvider
      classType={CustomFieldClassType.ConstructionAdminSubmittal}
    >
      <CIMSTabs
        prefix={
          <Warnings
            preface={
              <Typography.Text>
                Customize the filename of exported Reports or Photos using a
                template system
              </Typography.Text>
            }
          />
        }
        initialTab="Reports"
        /**
         * there's a bit of copy/pasta between these two components, but most of
         * the time it's because passing apollo queries between components is
         * pretty unwieldy
         */
        tabs={[
          {
            component: (
              <ReportRecordSelectProvider>
                <ReportFilenamesProvider>
                  <ReportFilenames />
                </ReportFilenamesProvider>
              </ReportRecordSelectProvider>
            ),

            key: 'Reports',
            label: 'Reports',
          },
          {
            component: (
              <PhotoExportRecordSelectProvider>
                <PhotoFilenamesProvider>
                  <PhotoFilenames />
                </PhotoFilenamesProvider>
              </PhotoExportRecordSelectProvider>
            ),
            key: 'Photos',
            label: 'Photos',
          },
        ]}
      />
    </ProjectCustomFieldsProvider>
  )
}

export default Filenames
